import React, { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { ROUTES } from "@constants/index";
import PropTypes from "prop-types";
import { ENV_OPTIONS } from "@constants";
import utils from "@utils";
import { SplashScreen } from "../../../../components";

const encodeQueryParameters = query => {
	const encodedQuery = Object.create(query);

	Object.keys(query).forEach(key => {
		encodedQuery[key] = encodeURIComponent(query[key]);
	});

	return encodedQuery;
};

const SignupRedirect = ({ redirectPolicy, router, operation, hiddenInputs }) => {
	const { instance } = useMsal();

	const msalRedirect = () => {
		instance
			.handleRedirectPromise()
			.then(() => {
				const {
					location: { query },
				} = router;

				if (hiddenInputs) {
					query.uxConfig = utils.encodeADState({ hiddenInputs });
				}

				instance.loginRedirect({
					authority: redirectPolicy,
					scopes: ENV_OPTIONS.adb2c.scopes,
					redirectUri: ROUTES.ADCallback,
					prompt: "login",
					state: utils.encodeADState({ operation }),
					extraQueryParameters: encodeQueryParameters(query),
				});
			})
			.catch(() => {
				router.push(ROUTES.root);
			});
	};

	useEffect(() => {
		msalRedirect();
	}, []);

	return (
		<div id="ad-signup">
			<SplashScreen />
		</div>
	);
};

SignupRedirect.propTypes = {
	redirectPolicy: PropTypes.string.isRequired,
	router: PropTypes.object.isRequired,
	operation: PropTypes.string.isRequired,
	hiddenInputs: PropTypes.arrayOf(PropTypes.string),
};

SignupRedirect.defaultProps = {
	hiddenInputs: undefined,
};

export default SignupRedirect;
